import React, {Fragment, useState, useEffect} from 'react'
import { Table, Placeholder, Icon, Accordion } from 'semantic-ui-react'

export function Market(props){

    console.log(props.market);

    return (
        <Fragment>
            <Accordion.Title onClick={props.onClick} active={props.active}>
                <Icon name='dropdown' /> {props.market.name}
            </Accordion.Title>
            <Accordion.Content active={props.active}>
                <p style={{
                    marginLeft: '2em'
                }}>
                    <div style={{
                        display: 'flex',
                        width: '100%'
                    }}>
                        <div>Canvas-ID:</div>
                        <div style={{marginLeft: '0.5em'}}>{props.market['oddset-id']}</div>
                        <div style={{marginLeft: '2em'}}>Uid:</div>
                        <div style={{marginLeft: '0.5em'}}>{props.market.uid}</div>
                    </div>
                    <Table basic='very' celled collapsing>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Tipp
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Quote
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Handicap
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Auswertung
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                    {
                        (typeof props.market.selection !== 'undefined' && props.market.selection !== null)?
                            props.market.selection.map((selection) => {
                                return (
                                    <Table.Row>
                                        <Table.Cell>
                                            {selection.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {selection.odd}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {selection.handicap}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                (typeof selection.correct === 'undefined' || selection.correct === null)?
                                                    <Icon name="clock outline" />
                                                :selection.correct?
                                                    <Icon name="check" />
                                                    :<Icon name="remove" />
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })
                        :null
                    }
                        </Table.Body>
                    </Table>
                </p>
            </Accordion.Content>
        </Fragment>
    );
}